import axios from "axios";
import { toast } from "react-toastify";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";
import {
  STATION_LOADING,
  STATION_ERROR,
  STATION_LIST,
  STATION_FILTERS
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../../common/requests";

const chargerUrl = `${settings.chargerUrl}api/`;
const ENDPOINT = "admin/station";

export const setLoading = (status) => ({
  type: STATION_LOADING,
  payload: status
});

export const getList = (criteria = []) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}/list`, {
    criteria
  })
    .then(response => {
      dispatch({
        type: STATION_LIST,
        payload: {
          content: response.data.content
        }
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    });
};

export const getSearch = (page = 0, size = 20, sort = "id,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters, chargerUrl)
    .then((response) => {
      dispatch({
        type: STATION_LIST,
        payload: response
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    });
};

export const getSingle = (filters = [], callback) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, 0, 1, "id,asc", filters, chargerUrl)
    .then(callback)
    .catch((error) => {
      callback(false);
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    });
};

export const add = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.post(`${chargerUrl}${ENDPOINT}`, data)
    .then(callback)
    .catch(error => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const stationEdit = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.patch(`${chargerUrl}${ENDPOINT}/${id}`, data)
    .then(callback)
    .catch(error => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const remove = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.delete(`${chargerUrl}${ENDPOINT}/${id}`)
    .then(() => {
      callback();
      toast(`Station ${id} successfully removed`, {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const updateStatus = (id, status, callback) => dispatch => {
  dispatch(setLoading(true));
  axios.patch(`${chargerUrl}${ENDPOINT}/${id}/status/${status}`)
    .then(() => {
      toast(`Station ${id} status successfully upaded`, {
        type: toast.TYPE.SUCCESS,
      });
      callback && callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    })
    .finally(() => {
      dispatch(setLoading(false));
    });
};


export const getFilters = () => dispatch => {
  requestCommonFilters(ENDPOINT, chargerUrl)
    .then((response) => {
      dispatch({
        type: STATION_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, STATION_ERROR));
    });
};

export const stationAddLogo = (stationId, file) => dispatch => {
  const formData = new FormData();
  formData.append("image", file, file.filename);
  return axios.patch(`${chargerUrl}${ENDPOINT}/${stationId}/images/main`, formData);
};

export const stationAddImages = (stationId, file) => dispatch => {
  const formData = new FormData();
  formData.append("image", file, file.filename);
  return axios.patch(`${chargerUrl}${ENDPOINT}/${stationId}/images`, formData);
};

export const removeImage = (stationId, imageId) => dispatch => axios.delete(`${chargerUrl}${ENDPOINT}/${stationId}/images/${imageId}`);



// WEBPACK FOOTER //
// ./src/actions/chargers/station/actions.js